document.addEventListener('DOMContentLoaded', () => {
    const reviewLists = document.querySelectorAll('.twz-element-review-list__slider');

    if (reviewLists) {

        reviewLists.forEach(reviewList => {
            if (reviewList.children.length > 3) {
                const Flickity = require('flickity');

                new Flickity(reviewList, {
                    pageDots: false,
                    watchCSS: true,
                    // autoPlay: 2500,
                    cellAlign:  'center',
                    prevNextButtons: true,
                    contain: true
                });
            }
        })

    }
});